'use client';

import { useEffect, useRef, type ReactNode } from 'react';
import gsap from 'gsap';

// Staggered fade-up for elements marked data-ow-reveal
export default function OurWorkReveal({ className, children }: { className?: string; children: ReactNode }) {
    const root = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!root.current || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const ctx = gsap.context(() => {
            gsap.from('[data-ow-reveal]', {
                y: 32,
                opacity: 0,
                filter: 'blur(8px)',
                duration: 0.9,
                ease: 'power3.out',
                stagger: 0.12,
                delay: 0.1,
            });
        }, root);
        return () => ctx.revert();
    }, []);

    return (
        <div ref={root} className={className}>
            {children}
        </div>
    );
}
